import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FacturaDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
export const columnasFijas: Column[] = [
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Fecha cancelación", cell: x => ({ data: kea.toDate(x.FechaCancelacion) }) },
    { title: "Serie-Folio", cell: x => ({ data: x.SerieFolio }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursalCobranza }) },
    { title: "Origen", cell: x => ({ data: models.OrigenFactura[x.Origen] }) },
    { title: "Cliente", cell: x => ({ data: x.NombreCliente }) },
    { title: "Subtotal", cell: x => ({ data: kea.formatCurrency(x.ImporteSubtotal) }) },
    { title: "Impuestos", cell: x => ({ data: kea.formatCurrency(x.TotalIVA + x.TotalIEPS) }) },
    { title: "Retenciones", cell: x => ({ data: kea.formatCurrency(x.TotalRetencionIVA) }) },
    { title: "Importe abonado", cell: x => ({ data: kea.formatCurrency(x.TotalAbonado) }) },
    { title: "Saldo", cell: x => ({ data: kea.formatCurrency(x.Saldo) }) },
    { title: "Fecha pago", cell: x => ({ data: kea.toDate(x.FechaPago) }) },
    { title: "Tiene retenciones", cell: x => ({ data: x.TieneRetencionesIVA }) },
    { title: "Total", cell: x => ({ data: kea.formatCurrency(x.ImporteTotal) }) },
    { title: "Contabilizada", cell: x => ({ data: x.Contabilizada }) },
    { title: "Cancelación Contabilizada", cell: x => ({ data: x.CancelacionContabilizada }) },
    { title: "Nota de crédito", cell: x => ({ data: x.FoliosNotaCredito }) },
    { title: "Facturas aplica nota de crédito", cell: x => ({ data: x.FolioFacturaOriginal }) },
    { title: "Timbrada", cell: x => ({ data: x.EsTimbrada }) },
    { title: "Cancelada", cell: x => ({ data: x.EsCancelada }) },
    { title: "Observaciones", cell: x => ({ data: x.Observaciones }) },
    { title: "Factura corregida", cell: x => ({ data: x.FolioFacturaCorregida }) },
    { title: "Folio factura corrigió", cell: x => ({ data: x.FolioFacturaCorrigio }) },
    { title: "Estatus cancelación", cell: x => ({ data: nullsafe(x.EstatusDeCancelacion, x => models.EstatusCancelacion[x]) }) },
    { title: "Mismos impuestos", cell: x => ({ data: x.MismosImpuestos }) },

];

export interface BotonesDeps {
    onEliminar: (item: Entity) => void;
    onEdit: (item: Entity) => void;
    onTimbrar: (item: Entity) => void;
    onCancelar: (item: Entity) => void;
    onGenerarNotaCredito: (item: Entity) => void;
    OnObtenerXML: (item: Entity) => void;
    OnObtenerPDF: (item: Entity) => void;
    OnObtenerPDFSinTimbrar: (x: Entity) => void;
    OnDuplicarFactura: (item: Entity) => void;
    RegenerarPolizaContable: (item: Entity) => void;
    onCorregirFactura: (item: Entity) => void;
    EnviarCorreo: (item: Entity) => void;
}

function botones(deps: BotonesDeps, permisos: models.Rol): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Modificar factura",
            style: "primary",
            iconClass: fa("pencil", "fw"),
            onClick: deps.onEdit
        }, {
            tooltip: "Timbrar",
            style: "warning",
            iconClass: fa("bell", "fw"),
            disabled: x => (x.EsTimbrada || x.EsCancelada || !permisos.Facturas.VerBotonTimbrarFactura),
            onClick: deps.onTimbrar
        }, {
            tooltip: "Generar nota de crédito",
            style: "success",
            iconClass: fa("tags", "fw"),
            disabled: x => (!x.EsTimbrada || x.EsNotaDeCredito || x.EsNotaDeCargo || x.PagadaCredito == true || !permisos.Facturas.VerGenerarNotaDeCredito),
            onClick: deps.onGenerarNotaCredito
        }, {
            tooltip: "Cancelar factura",
            style: "danger",
            iconClass: fa("times-circle-o", "fw"),
            disabled: x => !permisos.Facturas.VerBotonCancelarFactura,
            onClick: deps.onCancelar
        }, {
            tooltip: "Obtener XML de la factura",
            style: "success",
            iconClass: fa("file-code-o", "fw"),
            disabled: x => !x.EsTimbrada,
            onClick: deps.OnObtenerXML
        }, {
            tooltip: "Obtener PDF de la factura",
            style: "danger",
            iconClass: fa("file-pdf-o", "fw"),
            disabled: x => !x.EsTimbrada,
            onClick: deps.OnObtenerPDF
        }, {
            iconClass: fa("file-pdf-o"),
            style: "info",
            onClick: deps.OnObtenerPDFSinTimbrar,
            tooltip: "Obtener comprobante PDF de la factura sin timbrar",
            disabled: x => x.EsTimbrada || x.EsCancelada
        }, {
            tooltip: "Eliminar factura",
            style: "danger",
            iconClass: fa("trash", "fw"),
            disabled: x => !permisos.Facturas.VerBotonEliminarFactura,
            onClick: deps.onEliminar
        }, {
            tooltip: "Duplicar factura",
            style: "info",
            iconClass: fa("copy", "fw"),
            disabled: x => !permisos.Facturas.DuplicarFactura,
            onClick: deps.OnDuplicarFactura
        }, {
            tooltip: "Regenerar Poliza de cancelacion",
            style: "info",
            iconClass: fa("reply-all", "fw"),
            disabled: x => !x.EsCancelada || !x.EsTimbrada || x.CancelacionContabilizada || !permisos.Facturas.VerBotonGenerarPolizaDeCancelacion,
            onClick: deps.RegenerarPolizaContable
        }, {
            tooltip: "Corregir factura",
            style: "info",
            iconClass: fa("exchange", "fw"),
            disabled: x => x.EsNotaDeCredito || !permisos.Facturas.VerBotonCorregirFacturaCobranza,
            onClick: deps.onCorregirFactura
        }, {
            tooltip: "Enviar correo",
            style: "info",
            disabled: x => x.EsCancelada || !x.EsTimbrada || !permisos.Facturas.VerBotonEnviarCorreoFactura,
            iconClass: fa("envelope", "fw"),
            onClick: deps.EnviarCorreo
        }

    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "350px"
            })
        })
    }
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps, permisos: models.Rol): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps, permisos), ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/list/columns.tsx